import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import tipoEducacaoList from '../../../business-rules/List/tipoEducacaoList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import simNaoList from '../../../business-rules/List/simNaoList'

import tipoSeguradoList from '../../../business-rules/List/tipoSeguradoList'

import tipoGrupoDespesaList from '../../../business-rules/List/tipoGrupoDespesaList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    processaAlteracaoEducacaoTipoEducacao,
    processaAlteracaoEducacaoIdadeFinal,
    processaAlteracaoEducacaoTemSeguro,
} from './DespesasServiceEducacao'



export const TablePaginationPadraoEducacao = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.educacaoPagination}
            nameRowsPerPage={'rowsPerPageEducacao'}
            namePage={'pageEducacao'}
            rowsPerPage={values.rowsPerPageEducacao}
            page={values.pageEducacao}
        />
    )
}

export const rowPertentePageEducacao = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageEducacao, values.rowsPerPageEducacao)
}

export const setPageInclusaoEducacao = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageEducacao', values.educacaoPagination, values.rowsPerPageEducacao)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`educacao[${ind}].familiar`}
            label={LABEL.familiar}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalEducacao}
            disabled={expandiu}
        />
    )
}

export const TipoEducacao = ({ TextFieldNumberSelectTipoEducacao, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoEducacao
            name={`educacao[${ind}].tipoEducacao`}
            placeholder={LABEL.tipoEducacao}
            value={item.tipoEducacao || ''}
            onChange={handleChange}
            list={tipoEducacaoList}
            onBlur={processaAlteracaoEducacaoTipoEducacao(item)}
            disabled={expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosEducacao = ({ values, setFieldValue, ind, arrayHelpers, simplificado }) => {

    return (
        !simplificado
            ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageEducacao', values.educacaoPagination, values.rowsPerPageEducacao, values.pageEducacao)
                    }}
                />
            :
                ''
    )
}

export const TipoPeriodicidadePagto = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelectRequired
            name={`educacao[${ind}].tipoPeriodicidadePagto`}
            label={LABEL.tipoPeriodicidadePagto}
            value={item.tipoPeriodicidadePagto || ''}
            onChange={handleChange}
            list={tipoPeriodicidadeList(false, false, false)}
            // onBlur: O recálculo do item.valorAcumulado quando altera o 
            // campo item.tipoPeriodicidadePagto é feito em calculaTotaisEducacao
            disabled={expandiu}
        />
    )
}

export const Valor = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`educacao[${ind}].valor`}
            label={LABEL.valor}
            value={item.valor || ''}
            onChange={handleChange}
            // onBlur: O recálculo do item.valorAcumulado quando altera o 
            // campo item.valor é feito em calculaTotaisEducacao
            disabled={expandiu}
        />
    )
}

export const ValorAcumulado = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`educacao[${ind}].valorAcumulado`}
            label={LABEL.valorAcumulado}
            value={item.valorAcumulado || ''}
            onChange={handleChange}
            disabled={true}
        />
    )
}

export const IdadeInicial = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`educacao[${ind}].idadeInicial`}
            label={LABEL.idadeInicial}
            value={item.idadeInicial === 0 ? 0 : item.idadeInicial || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            // onBlur: O recálculo do item.valorAcumulado quando altera o 
            // campo item.idadeInicial é feito em calculaTotaisEducacao
            disabled={expandiu}
        />
    )
}

export const IdadeFinal = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorNumberRequired
            name={`educacao[${ind}].idadeFinal`}
            label={LABEL.idadeFinal}
            value={item.idadeFinal === 0 ? 0 : item.idadeFinal || ''}
            onChange={handleChange}
            numMin={NUMMIN.idade}
            numMax={NUMMAX.idade}
            onBlur={processaAlteracaoEducacaoIdadeFinal(item, values)}
            // onBlur: O recálculo do item.valorAcumulado quando altera o 
            // campo item.idadeFinal é feito em calculaTotaisEducacao
            disabled={expandiu}
        />
    )
}

export const TemSeguro = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelectRequired
            name={`educacao[${ind}].temSeguro`}
            label={LABEL.temSeguro}
            value={item.temSeguro || ''}
            onChange={handleChange}
            list={simNaoList}
            onBlur={processaAlteracaoEducacaoTemSeguro(item)}
        />
    )
}

export const TipoSegurado = ({ values, item, ind, handleChange }) => {

    return (
        <TextFieldTextSelectRequired
            name={`educacao[${ind}].tipoSegurado`}
            label={LABEL.tipoSegurado}
            value={item.tipoSegurado || ''}
            onChange={handleChange}
            list={tipoSeguradoList(values)}
        />
    )
}

export const GrupoDespesa = ({ item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelectRequired
            name={`educacao[${ind}].grupoDespesa`}
            label={LABEL.grupoDespesa}
            value={item.grupoDespesa || ''}
            onChange={handleChange}
            list={tipoGrupoDespesaList}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`educacao[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}